const formConfig = {
  name: "employeeLogin",
  fields: {
    username: {
      id: "employee-phone",
      jsonPath: "employee.username",
      required: true,
      floatingLabelText: "CORE_COMMON_NAME",
      errorMessage: "CORE_COMMON_USERNAME_INVALIDMSG",
      hintText: "CORE_LOGIN_USERNAME_PLACEHOLDER",
      pattern: "^[a-zA-Z0-9]+([_ -]?[a-zA-Z0-9])*$",
      value: "",
    },
    password: {
      id: "employee-password",
      jsonPath: "employee.password",
      required: true,
      type: "password",
      floatingLabelText: "CORE_LOGIN_PASSWORD",
      errorMessage: "CORE_LOGIN_PASSWORD_ERRORMSG",
      hintText: "CORE_LOGIN_PASSWORD_PLACEHOLDER",
      pattern: "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*_-])[A-Za-z0-9!@#$%^&*_-]+$",
      value: "",
      style:{},
    },
    city: {
      id: "person-city",
      jsonPath: "employee.tenantId",
      required: true,
      floatingLabelText: "ULB",
      hintText: "Select ULB",
    },
  },
  submit: {
    label: "CONTINUE",
    id: "login-submit-action",
    type: "submit",
  },
  saveUrl: "/user-otp/v1/_send",
  redirectionRoute: "/inbox",
  action: "token",
};

export default formConfig;



// WEBPACK FOOTER //
// src/config/forms/specs/employeeLogin.js